import {NavigationItem} from './app.types';

/**
 * A list of the main navigation entry items
 *
 * @type {{label: string; iconType: string; iconSrc: string; routeTarget: string[]}[]}
 */
export const navigationItems: NavigationItem[] = [
  {
    label: 'Projects',
    iconType: 'icon',
    iconSrc: 'icon-project',
    routeTarget: ['projects'],
  },
  // new section
  {
    label: 'Features',
    iconType: 'icon',
    iconSrc: 'icon-feature-types',
    routeTarget: ['features'],
  },
  {
    label: 'Model Editor',
    iconType: 'icon',
    iconSrc: 'icon-models',
    routeTarget: ['model-editor'],
  }
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/base-app/app.navigation.ts